import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmationModalComponent } from './components/confirmation-modal/confirmation-modal.component';
import {
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogModule,
    MatDialogTitle
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import {
    DisableConfirmationModalComponent
} from './components/disable-confirmation-modal/disable-confirmation-modal.component';
import { TranslateModule } from '@ngx-translate/core';
import { CookiesDisclaimerComponent } from './components/cookies-disclaimer/cookies-disclaimer.component';
import { MatTabsModule } from '@angular/material/tabs';

@NgModule({
    declarations: [
        ConfirmationModalComponent,
        DisableConfirmationModalComponent,
        CookiesDisclaimerComponent
    ],
    imports: [
        CommonModule,
        MatDialogModule,
        MatButtonModule,
        MatDialogTitle,
        MatDialogContent,
        MatDialogActions,
        MatDialogClose,
        TranslateModule,
        MatTabsModule
    ],
    exports: [ConfirmationModalComponent, CookiesDisclaimerComponent]
})
export class CommonSharedModule {
}
